import * as React from "react";
const SvgChevronLeft20 = (props, ref) => React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ref: ref, ...props },
    React.createElement("path", { fill: "currentColor", d: "M12.28 4.22a.75.75 0 0 1 0 1.06L7.56 10l4.72 4.72a.75.75 0 0 1-1.06 1.06l-5.25-5.25a.75.75 0 0 1 0-1.06l5.25-5.25a.75.75 0 0 1 1.06 0Z" }));
const ForwardRef = React.forwardRef(SvgChevronLeft20);
export default ForwardRef;
